module.exports = __webpack_public_path__ + "img/logo.ca6998b6.png";